module.exports = __webpack_public_path__ + "static/media/searchIcon.939ef6f9.svg";